export const EnabledSmartSearchKey = 'Enabled';
export const DisabledSmartSearchKey = 'Disabled';

export enum SmartSearchTemplateKeys {
  Admin = 'Admin',
  BrandingName = 'Branding-name',
  Company = 'Company',
  Computer = 'Computer',
  DNSName = 'Dns-name',
  LicensesSettings = 'Licenses Settings',
  Status = 'Status',
  StorageType = 'Storage-type',
  Type = 'Type'
}

export const SmartSearchTemplateMap: Map<SmartSearchTemplateKeys, { tag: SmartSearchTemplateKeys; prop: string }> = new Map([
  [SmartSearchTemplateKeys.DNSName, { tag: SmartSearchTemplateKeys.DNSName, prop: 'dnsName' }]
]);
